import VideoMessage from './VideoMessage';

export default VideoMessage;
